import { render, staticRenderFns } from "./chat-page.vue?vue&type=template&id=3815c196&"
import script from "./chat-page.vue?vue&type=script&lang=js&"
export * from "./chat-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports